'use strict';

import {getLabcodeApiBaseUrl} from './labcode-api';
import {getLabcodeStaffToken} from './labcode-staff-session';

async function staffJson (path, options = {}) {
    const base = getLabcodeApiBaseUrl();
    const token = getLabcodeStaffToken();
    if (!base || !token) {
        throw new Error('Sessão de equipa escolar ou API não disponível.');
    }
    const res = await fetch(`${base}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            ...(options.headers || {})
        }
    });
    const text = await res.text();
    let data = {};
    let jsonOk = false;
    const trimmed = text && text.trim ? text.trim() : '';
    if (trimmed.length) {
        try {
            data = JSON.parse(trimmed);
            jsonOk = true;
        } catch (e) {
            jsonOk = false;
        }
    }
    if (!res.ok) {
        if (!jsonOk && trimmed.length) {
            const expressCantMethod = /cannot\s+(post|get|put|patch|delete)\s+\//i.test(trimmed);
            const looksHtml = /^\s*</.test(trimmed) || expressCantMethod;
            if (looksHtml) {
                throw new Error(
                    'O labcode-server em execução não reconhece este pedido (404 — provavelmente código antigo sem a rota). ' +
                    'Reinicie o servidor: na pasta labcode-server, pare o Node e volte a correr npm start. ' +
                    'Confirme também que REACT_APP_LABCODE_API_URL no openblock-gui aponta para esse API (ex.: http://127.0.0.1:3000).'
                );
            }
        }
        throw new Error(
            (jsonOk && data.error) || `Pedido falhou (${res.status}).`
        );
    }
    if (!jsonOk && trimmed.length) {
        throw new Error('Resposta inválida da API (esperava-se JSON).');
    }
    return data;
}

export function staffGetMe () {
    return staffJson('/staff/me');
}

export function staffGetTeachers (schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/teachers${q}`);
}

export function staffCreateTeacher (body) {
    return staffJson('/staff/teachers', {
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function staffGetDashboard (schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/dashboard${q}`);
}

export function staffGetSchools () {
    return staffJson('/staff/schools');
}

export function staffCreateSchool (body) {
    return staffJson('/staff/schools', {
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function staffResetCoordinatorPassword (schoolId, body) {
    return staffJson(
        `/staff/schools/${encodeURIComponent(schoolId)}/coordinator/reset-password`,
        {
            method: 'POST',
            body: JSON.stringify(body)
        }
    );
}

export function staffGetClasses (schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/classes${q}`);
}

export function staffCreateClass (body) {
    return staffJson('/staff/classes', {
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function staffPatchClass (classId, body, schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(
        `/staff/classes/${encodeURIComponent(classId)}${q}`,
        {
            method: 'PATCH',
            body: JSON.stringify(body)
        }
    );
}

export function staffGetStudents (classId, schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/classes/${encodeURIComponent(classId)}/students${q}`);
}

export function staffAddStudent (classId, nickname, schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/classes/${encodeURIComponent(classId)}/students${q}`, {
        method: 'POST',
        body: JSON.stringify({ nickname })
    });
}

export function staffAddStudentsBulk (classId, nicknames, schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(`/staff/classes/${encodeURIComponent(classId)}/students/bulk${q}`, {
        method: 'POST',
        body: JSON.stringify({ nicknames })
    });
}

export function staffRemoveStudent (classId, studentId, schoolId) {
    const q = schoolId ? `?schoolId=${encodeURIComponent(schoolId)}` : '';
    return staffJson(
        `/staff/classes/${encodeURIComponent(classId)}/students/${encodeURIComponent(studentId)}${q}`,
        { method: 'DELETE' }
    );
}

export function staffGetProjects ({ schoolId, classId, limit } = {}) {
    const p = new URLSearchParams();
    if (schoolId) p.set('schoolId', schoolId);
    if (classId) p.set('classId', classId);
    if (limit) p.set('limit', String(limit));
    const qs = p.toString();
    return staffJson(qs ? `/staff/projects?${qs}` : '/staff/projects');
}
